<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-11-18 15:13:23
 * @Description: file content
 rule rank prize
 规则、排行、奖品
 -->
<template>
  <div :class="['mymodal', { animate: value && message.animate }]" v-show="value">
    <div class="info" :style="{ transform: this.message.animate ? 'scale(0)' : 'none' }">
      <!-- <img class="form-title" src="http://assets.rurushishi.com/activies/hhjx-purchase/form1.png" /> -->
      <img class="modalTitle" :src="configInfo.popupStyleImg" />
      <div class="msg-info">
        <div class="msgTitle">
          {{ message.type == "thanks" ? (message.siteIndex == 1 ? "恭喜您" : "太遗憾了") : "领取奖品" }}
        </div>
        <div class="msg" v-html="text"></div>
        <template class="" v-if="message.type != 'thanks'">
          <div class="msg" v-if="message.lotteryPrizeTimeoutTime">奖品将于{{ parseInt(message.lotteryPrizeTimeoutTime) | dformat }}过期</div>
          <div class="tel-wrap">
            <input @blur="blurInput" v-model="userWriteForm.name" type="text" placeholder="姓名" />
          </div>
          <div class="tel-wrap" v-if="ismobile!=1">
            <input @blur="blurInput" v-model="userWriteForm.mobile" type="tel" placeholder="手机号码" />
          </div>
          <div class="tel-wrap select-wrap" v-if="message.prizeType == 2 || message.prizeType == 4 || message.prizeType == 5">
            <Multiselect v-model="userWriteForm.address" :options="addressList" placeholder="兑换地址" :searchable="false" :allow-empty="false" :show-labels="false" track-by="address" label="address">
              <template slot="singleLabel" slot-scope="{ option }">
                {{ option.address }}
              </template>
            </Multiselect>
          </div>
          <div class="ver-container" v-if="ismobile!=1">
            <input @blur="blurInput" v-model="userWriteForm.code" maxlength="6" oninput="if(value.length>6)value=value.slice(0,6)" type="number" placeholder="验证码" />
            <div class="ver-btn" @click="clickCode">{{ verShowTxt }}</div>
          </div>
          <div
            class="submit act-text-stroke"
            :style="{
              backgroundColor: configInfo.buttonBackgroundColour,
              color: configInfo.buttonTextColour,
            }"
            @click="clickBottomBtn"
          >
            立即领取<span v-if="time"> ({{ time }})</span>
          </div>
        </template>
        <div
          v-else
          class="submit act-text-stroke"
          :style="{
            backgroundColor: configInfo.buttonBackgroundColour,
            color: configInfo.buttonTextColour,
          }"
          @click="clickBottomBtnConfirm"
        >
          确定
        </div>
      </div>
      <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import { Toast, MessageBox } from "mint-ui";
import { handlerYqAnalyticsEvent } from "@/utils/biz";

export default {
  components: { Multiselect },
  props: {},
  data() {
    return {
      value: false,
      callback: null,
      message: "",
      userWriteForm: {
        name: "",
        mobile: "",
        code: "",
        address: {},
      },
      mobile: "",
      addressList: [],
      isCanVer: true, //是否能发送验证码
      verShowSec: 60, //读秒
      verShowTxt: "获取验证码",
      ismobile: 0, //1 有电话、0 没电话
      timeInterval: null,
      timeInterval2: null,
      configInfo: {},
      text: "",
      time: 0,
      isClick: false,
      wxWorkImg:'',
    };
  },
  watch: {
    userWriteForm: {
      handler() {
        if (this.userWriteForm.code.length > 6) {
          this.userWriteForm.code = this.userWriteForm.code.substring(0, 6);
        }
      },
      deep: true,
    },
    value: function (newVal) {
      if (newVal) {
        if (this.message.type == "thanks") {
          this.text = `感谢您的参与，分享活动还有更多惊喜，继续加油吧！`;

          if (this.message.siteIndex && this.message.siteIndex == 1) {
            this.text = `您成功点亮${this.message.name}站，<br/>呼朋唤友点亮下一站,超多精彩好礼等您来拿。`;
          }
        } else {
          console.log(this.message.deadline);
          if (this.message.deadline) {
            let time = parseInt((this.message.deadline - new Date().getTime()) / 1000);
            this.time = time;
            this.upDataText(time);
          }
          if (this.message.category == 1) {
            this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`; //<br/>请在${time}秒内领奖.
          } else {
            this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`;
          }
          if (this.message.siteIndex && this.message.siteIndex == 1) {
            this.text = `您成功点亮${this.message.name}站，<br />为您准备了${this.message.prizeName}，请正确填写信息后领取。`;
          }
          if (this.message.type == "helpPrize") {
            this.text = `恭喜您成功帮助好友完成助力！奖励您一个随机金喜，请正确填写信息后领取。`;
          }
          // 判断是否有地址
          // this.getPrizeById();
          // 打开弹框 message接收prizeInfo
          // 判断是否有电话
          console.log(this.$userInfo);
          this.userWriteForm.name = this.$userInfo ? this.$userInfo.nickname : "";
          this.userWriteForm.mobile =  sessionStorage.getItem("mobile");
          if (this.userWriteForm.mobile) {
            this.ismobile = 1;
            // this.userWriteForm.mobile = this.message.mobile;
          }
          if (!this.userWriteForm.mobile) {
            this.userWriteForm.mobile = localStorage.getItem("prize_mobile") || "";
          }
        }
      } else {
        //关闭清空form数据,不清空倒计时
        this.time = 0;
        this.verShowTxt = "获取验证码";
        clearInterval(this.timeInterval2);
        clearInterval(this.timeInterval);
        this.userWriteForm = {
          name: "",
          mobile: "",
          code: "",
          address: "",
        };
        this.isCanVer = true; //是否能发送验证码
        this.verShowSec = 60; //读秒
      }
    },
    message: function (newVal, oldval) {
      console.log(newVal, oldval);
      const configInfo = this.configInfo;
      console.log(configInfo);
      if (configInfo.receiveAddress) {
        let addressList = [];
        //   this.addressList = [
        //     { address: "武汉", type: 1 },
        //     { address: "上海", type: 2 },
        //     { address: "北京", type: 3 },
        //   ];
        JSON.parse(configInfo.receiveAddress).map((item, index) => {
          addressList.push({ address: item, type: index });
        });
        this.userWriteForm.address = addressList[0];
        this.addressList = addressList;
      }
      if (oldval != "" && oldval.prizeCode != newVal.prizeCode) {
        // console.log('有变化')
        this.verShowTxt = "获取验证码";
        this.userWriteForm = {
          name: "",
          mobile: "",
          code: "",
          address: "",
        };
        this.isCanVer = true; //是否能发送验证码
        this.verShowSec = 60; //读秒
      }
    },
  },
  computed: {
    infoStyle() {
      return {
        backgroundColor: this.configInfo.popupBackgroundColour,
      };
    },
  },
  mounted() {
    // this.configInfo =this.$configInfo ;
    this.configInfo = this.$configInfo;
    if(this.configInfo.bizType==4||this.configInfo.bizType==3){
      this.wxWorkImg =this.$util.cookie.get('receivePrizePage')
    }else{
      this.wxWorkImg =this.$util.cookie.get('wxWorkImg')
    }
  },
  methods: {
    //取消领奖
    clickClose() {
      console.log(this.message);
      if (this.message.type == "thanks"||this.message.type =='code') {
        this.value = false;
        this.callback("cancel");
        return;
      }
      let mess=`奖品将于${this.time}秒内失效,请尽快领取哦!`
      let isRecycle=false
      let confirmButtonText='领取'
      let cancelButtonText='关闭'
      // 不是第一站 也不是必中红包 
      if(this.message.siteIndex!=1&&this.message.winType!=1){
        mess="现在退出，视为放弃奖品，奖品将会释放给其他用户哦～请您慎重考虑！"
        isRecycle=true
      }
      if (this.message.type == "helpPrize") {
        mess="现在退出，随机金喜视为自动放弃，请您慎重考虑哦！"
        isRecycle=true
      }
      if (this.message.winType == 5) {
        mess="优惠券一眨眼就没了，确认放弃吗？"
        confirmButtonText='我再想想'
        cancelButtonText='确定'
        isRecycle=false
      }
      MessageBox({
        title: "提示",
        message: mess,
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
      }).then((action) => {
        if (action == "confirm") {
          console.log("领取");
        } else {
          console.log("关闭");
          if(isRecycle){
            this.recycle()
          }
          this.value = false;
          this.callback("cancel");
        }
      });
    },
    // 直接回收奖品
    async recycle(){
      let param = this.$apizt.action.recycle.api+`/${this.message.receiveKey}`;
      const {code,data}= await this.$httpzt.requestRestFul(param, null,'post');
      if(code==200){
        console.log(data)
      }
    },
    upDataText(time) {
      this.timeInterval2 = setInterval(() => {
        time--;
        if (time < 0) {
          this.$showToast({
            message: "奖品已过期,无法领取",
            duration: 1000,
          });
          this.value = false;
          this.callback("cancel");
        }
        this.time = time;
        // this.text = `恭喜您获得${this.message.prizeName}，请填写信息领取奖品。`; //<br/>请在${time}秒内领奖.
      }, 1000);
    },
    //获取奖品详情
    getPrizeById() {
      let url = this.$apizt.turntable.getPrizeById.api;
      this.$httpdf.get(`${url}`, { prizeId: this.message.prizeId }, { res: "data" }).then((data) => {
        console.log("获取奖品详情: ", data);
        if (data.code != 200) {
          return this.$showToast({
            message: data.msg || "网络连接错误,请重试",
            duration: 1000,
          });
        } else {
          if (data.data.address && data.data.address.length > 0) {
            this.addressList = [];
            data.data.address.forEach((v, i) => {
              let obj = {};
              obj.addressId = v.addressId;
              obj.address = v.addressName;
              obj.name = v.addressName;
              obj.id = i;
              this.addressList.push(obj);
            });
          }
        }
      });
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      this.temporaryRepair();
    },
    // 点击获取验证码
    async clickCode() {
      if (this.isCanVer) {
        var mobile = this.userWriteForm.mobile;
        if (mobile.length == 0) {
          Toast({ message: "请输入手机号", duration: 1000 });
        } else if (!this.$util.isMobile(mobile)) {
          Toast({ message: "请输入正确的手机号！", duration: 1000 });
        } else {
          this.isCanVer = false;
          this.verShowTxt = this.verShowSec + "s";
          this.verShowSec--;
          this.timeInterval = setInterval(() => {
            if (this.isCanVer == false) {
              if (this.verShowSec == 0) {
                this.verShowTxt = "获取验证码";
                this.isCanVer = true;
                this.verShowSec = 60;
                clearInterval(this.timeInterval);
              } else {
                this.verShowTxt = this.verShowSec + "s";
                this.verShowSec--;
              }
            }
          }, 1000);

          //获取验证码
          let param = this.$apizt.action.getSmsCode;
          const { code } = await this.$httpzt.requestRestFul(param, {
            mobile: mobile,
          });
          // if (result) {
          //   console.log(data);
          // }
          if (code == 200) {
            this.$showToast("验证码已发送,请查收!");
          } else {
          }
        }
      }
    },
    //提交事件
    clickBottomBtn() {
      if (this.isClick) {
        return;
      }
      this.isClick = true;
      var phone = this.userWriteForm.mobile || "";
      var vercode = this.userWriteForm.code || "";
      var address = this.userWriteForm.address || "";
      if (phone.length == 0 && this.ismobile == 0) {
        this.isClick = false;
        Toast({ message: "请输入手机号", duration: 1000 });
      } else if (!this.$util.isMobile(phone) && this.ismobile == 0) {
        this.isClick = false;
        Toast({ message: "请输入正确的手机号！", duration: 1000 });
      } else if (vercode.length == 0 && this.ismobile == 0) {
        this.isClick = false;
        Toast({ message: "请输入验证码！", duration: 1000 });
      } else {
        // handlerYqAnalyticsEvent("entryPhoneNumber", {
        //   phoneNumber: phone,
        //   rscuid:this.$fromSaleOpenId||'',
        //   refereeopenid:this.$fopenid||'',
        //   type: 13,
        //   bizSource: 9,
        // });
        this.$userInfo.mobile = phone;
        // this.$rsh5.actEntry(phone);
        /***********************************/
        // if (this.message.type == "helpPrize") {
        //   // 领取话费
        //   this.receiveAssistancePrize();
        // }else if (this.message.type == "buyLottery") {
        //   // 领取抽奖奖品
        //   this.receive();
        // } else if (this.message.type == "coupon") {
        //   // 免费领券
        //   if(this.message.winType==4)
        //     this.receiveCoupon();
        //   else if(this.message.winType==5)
        //     this.getPayUrl();
        // } else if(this.message.category==4){
        //   // 领取排行榜奖品
        //   this.checkReceiveField();
        // }else {
        //   // 领取
        //   this.checkField();
        // }

        console.log(this.message);
        if (this.message.winType == 5) {
          this.getPayUrl();
        } else if (this.message.type == "key" || this.message.type == "helpPrize") {
          this.receiveKeyPrize();
        } else if (this.message.type == "code") {
          this.receiveCodePrize();
        }
      }
    },
    // 抽奖奖品
    async receive() {
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        this.isClick = false;
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receive;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      this.isClick = false;
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    // 领取助力奖品
    async checkField() {
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        this.isClick = false;
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.assistanceReceive;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      this.isClick = false;
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    async receiveAssistancePrize() {
      // 领取助力奖品
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        this.isClick = false;
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receiveAssistancePrize;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      this.isClick = false;
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    async receiveCoupon() {
      if (!this.userWriteForm.address) {
        this.isClick = false;
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      this.mobile = this.userWriteForm.mobile;
      let param = this.$apizt.action.receiveCoupon;
      const { code } = await this.$httpzt.requestRestFul(param, {
        address: this.userWriteForm.address.address,
        code: this.userWriteForm.code,
        mobile: this.userWriteForm.mobile,
        name: this.userWriteForm.name,
        receiveKey: this.message.receiveKey,
      });
      this.isClick = false;
      if (code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    clickBottomBtnConfirm() {
      this.value = false;
      if (this.message.share !== false && this.configInfo.shareSwitch == 1) {
        let text = {
          text1: "邀请好友",
          text2: "还有更多惊喜",
          text3: "",
        };
        this.$modal.share.alert(text).then((data) => {
          if (data == "save") {
            console.log(this.configInfo.shareImg);
            this.$modal.poster.alert({
              gameBg: this.configInfo.shareImg, //分享截图背景图
            });
          }
        });
      }
    },
    // 领取排行榜奖品
    async checkReceiveField() {
      const { mobile, name, code, address } = this.userWriteForm;
      if (!address) {
        this.isClick = false;
        Toast({
          message: "请选择领奖地址",
          duration: 1000,
        });
        return;
      }
      let param = this.$apizt.action.receive;
      const res = await this.$httpzt.requestRestFul(param, {
        address: address.address,
        code: code,
        mobile: mobile,
        name: name,
        receiveKey: this.message.receiveKey,
      });
      this.isClick = false;
      if (res.code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    async receiveKeyPrize() {
      this.mobile = this.userWriteForm.mobile;
      let param = this.$apizt.action.receiveV2;
      const { code } = await this.$httpzt.requestRestFul(param, {
        address: this.userWriteForm.address.address,
        code: this.userWriteForm.code,
        mobile: this.userWriteForm.mobile,
        name: this.userWriteForm.name,
        receiveKey: this.message.receiveKey,
      });
      this.$hideLoading();
      localStorage.setItem("prize_mobile", this.mobile);
      this.isClick = false;
      if (code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        sessionStorage.setItem("mobile",this.mobile);
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    async receiveCodePrize() {
      this.mobile = this.userWriteForm.mobile;
      let param = this.$apizt.action.win;
      const { code } = await this.$httpzt.requestRestFul(param, {
        address: this.userWriteForm.address.address,
        code: this.userWriteForm.code,
        mobile: this.userWriteForm.mobile,
        name: this.userWriteForm.name,
        prizeCode: this.message.receiveKey,
      });
      this.$hideLoading();
      localStorage.setItem("prize_mobile", this.mobile);
      this.isClick = false;
      if (code == 200) {
        this.value = false;
        Toast({
          message: "领取成功",
          duration: 1000,
        });
        sessionStorage.setItem("mobile",this.mobile);
        this.callback("success");
        if (this.configInfo.wxWorkSwitch&&this.wxWorkImg) {
          this.$modal.formSuccess.alert();
        }
      }
    },
    // 付费券 支付链接
    async getPayUrl() {
      this.mobile = this.userWriteForm.mobile;
      let param = this.$apizt.action.getPaymentUrl;
      const { code, data } = await this.$httpzt.requestRestFul(param, {
        appId: this.$appId,
        folder: "index",
      });
      this.$hideLoading();
      this.isClick = false;
      if (code == 200) {
        const { payUrl, payAppId } = data;
        console.log(data);

        const addPay = {
          address: this.userWriteForm.address.address,
          code: this.userWriteForm.code,
          mobile: this.userWriteForm.mobile,
          name: this.userWriteForm.name,
          payType: 0,
          lockId: this.message.receiveKey,
        };
        let rurl = encodeURIComponent(`${this.$site}#/index?actCode=${this.$actCode}&channel=${this.$channel}&fopenid=${this.$fopenid}&receiveKey=${this.message.receiveKey}`);
        let url = `${payUrl}?appid=${payAppId}&query=${encodeURIComponent(JSON.stringify(addPay))}&rurl=${rurl}&fopenid=${this.$fopenid}&actCode=${this.$actCode}&dm=${process.env.VUE_APP_DM}&reQuest=circle-act-game-assistance&questUrl=${encodeURIComponent("act/m/common/prize/buyLockCoupon")}&cancelUrl=&actOpenId=${this.$openid}`;
        console.log(url);
        window.location.href = url;
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="stylus" scoped>

@keyframes modal_animate {
  0 {
    transform: scale(0)
  }
  100% {
    transform: scale(1)
  }
}

.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  &.modal-blindbox {
    .msg-info {
      border-style:solid;
      border-width:12px 12px 18px;
      position:relative;
      &::after {
        content:'';
        position:absolute;
        bottom:-7px;
        left:0;
        right:0;
        height:8px;
        background: url(https://assets.rurushishi.com/activies/activityCenter/blindboxLottery/circle-line.png?v=20220124) no-repeat center;
        background-size:100% auto;
      }
    }
  }

  &.animate{
    .info{
      animation-name:modal_animate;
    }
  }

  .info {
    position: relative;
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    animation-timing-function: ease-out;
    animation-duration: 1s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    transform: scale(0)

    .modalTitle {
      position: relative;
      width: 300px;
      z-index: 1;
    }

    .msg-info {
      position: relative;
      z-index: 0;
      margin-top: -1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-radius: 0px 0px 16px 16px;
      width: 100%;
      box-sizing: border-box;
      padding-bottom: 24px;
      background-color: #fff;

      .msgTitle {
        font-weight: 600;
        font-size: 24px;
        line-height: 32px;
        color: #262626;
        margin-top: 10px;
      }

      .msg {
        font-size: 14px;
        line-height: 20px;
        margin-top: 12px;
        color: #595959;
        width: 240px;
        margin-bottom: 12px;
        word-break: break-all;
      }

      .tel-wrap, .ver-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 240px;
        height: 40px;
        margin-bottom: 12px;
        font-size: 14px;
      }

      .tel-wrap input {
        width: 240px;
        height: 40px;
        padding: 10px;
        background: #F8F8FB;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 6px;
        box-sizing: border-box;
      }

      input::-webkit-input-placeholder {
        color: #595959;
      }

      .ver-container input {
        width: 132px;
        height: 40px;
        padding: 10px;
        background: #F8F8FB;
        border: 1px solid #EEF0F3;
        box-sizing: border-box;
        border-radius: 6px;
        box-sizing: border-box;
      }

      .ver-btn {
        width: 100px;
        height: 40px;
        border: 1px solid #EF1350;
        box-sizing: border-box;
        border-radius: 6px;
        font-weight: 500;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        color: #EF1350;
      }

      .multiselect {
        height: 40px;
        border-radius: 6px;
      }

      .select-wrap >>> .multiselect__tags {
        height: 40px;
        font-size: 14px;
        padding: 0;
        border-radius: 6px;
        border: 1px solid #EEF0F3;
        background: #F8F8FB;
        padding: 10px;
      }

      .select-wrap >>> .multiselect__placeholder {
        color: #595959;
        line-height: 20px;
        font-family: tahoma, arial, 'Hiragino Sans GB', simsun, sans-serif;
      }

      .select-wrap >>> .multiselect__single {
        font-size: 14px;
        background: transparent;
        padding: 0;
        margin-bottom: 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          line-clamp: 1;
          -webkit-box-orient: vertical;
      }

      .submit {
        margin-top: 12px;
        width: 220px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 20px;
        border-radius: 24px;
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
        font-weight: 600;
      }
    }

    .close {
      position: relative;
      width: 40px;
      height: 40px;
      z-index: 1002;
      margin-top: 28px;
    }
  }
}
</style>
